import api from "@/plugins/api/EntryPoint";

export default {
  async getPaymentHistory(params, callBackFn) {
    console.log("Payment HISTORY " + JSON.stringify(params))
    await api.post(`history/payments`, params, callBackFn);
  },
};
